module.exports = __webpack_public_path__ + "img/Turbilatex Reagents 01.2 (mid).b5cbd287.jpg";